<template>
	<div class="headerTop">
    <span style="font-weight: 600;font-size: 20px;">
		<img style="vertical-align: middle;height: 48px;width:auto !important;" width="140px" v-if="customerLogo!=null" :src="customerLogo" />
		<img style="vertical-align: middle;height: 48px;width:auto !important;"  v-else src="@/assets/logo.png" />
    {{this.customerName}}</span>
		<div v-if="userInfo">
			<font style="font-size: 14px;margin-right: 10px;" color="#96A0A0">{{week}} {{time}}</font>
			<el-dropdown  @command="editPasd" style="cursor: pointer;">
			      <span class="el-dropdown-link">
			        {{JSON.parse(userInfo).userName }}<i class="el-icon-arrow-down el-icon--right"></i>
			      </span>
			      <el-dropdown-menu slot="dropdown">
			        <el-dropdown-item command="edit" icon="el-icon-edit-outline">修改密码</el-dropdown-item>
			        <el-dropdown-item command="exit" icon="el-icon-wallet">退出登录</el-dropdown-item>
			      </el-dropdown-menu>
			    </el-dropdown>
		</div>

	</div>
</template>

<script>
import {getInfo, logout} from '../../api/login.js'
	import {getScreenInfo} from '@/api/user.js'
	export default {
	  name:'headerTop',
	  data() {
	    return {
			week:'',
			time:'',
			userInfo:'',
      customerName:'',
			baseH:window.imgUrl,
      baseUrl:window.baseUrl,
      customerLogo:null
		}
	  },
	   watch: {
	      '$store.state.userInfo'(newValue, oldValue) {
	        this.userInfo = newValue;
          if(this.userInfo!=null&&''!==this.userInfo){
            console.log('top')
            // 在这里执行你的逻辑
            this.customerName=JSON.parse(this.userInfo).customerName;
            if(JSON.parse(this.userInfo).loginLogo!=null){
              this.customerLogo=this.baseH + JSON.parse(this.userInfo).loginLogo;
            }else{
              this.customerLogo = 'logo_stu.png';
              var link = document.querySelector('link[rel*="icon"]');
              link.href='logo_stu.png';
            }
            if(JSON.parse(this.userInfo).loginName!=undefined&&JSON.parse(this.userInfo).loginName!=null&&JSON.parse(this.userInfo).loginName!=''){
              var title = document.querySelector('title');
              title.text=JSON.parse(this.userInfo).loginName;
            }else{
              var title = document.querySelector('title');
              title.text='智能心理测评管理系统';
            }
          }
	      },
       '$store.state.logoInfo'(newValue, oldValue) {
          this.customerLogo = this.baseH + newValue;
       }
	    },
	  mounted() {
		  const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
		  const today = new Date().getDay();
		  this.week = weekDays[today];
      this.init();
      console.log('top1')
      console.log(this.$store.state.userInfo)
      console.log(this.$store.state.logoInfo)
      if(this.$store.state.logoInfo!=null){
        this.customerLogo = this.baseH + this.$store.state.logoInfo;
      }
      if(this.$store.state.userInfo){
        this.userInfo = this.$store.state.userInfo
        if(JSON.parse(this.userInfo).loginName!=null){
          localStorage.setItem('loginName',JSON.parse(this.userInfo).loginName);
        }else{
          localStorage.setItem('loginName','智能心理测评管理系统');
        }
        this.customerName=JSON.parse(this.userInfo).customerName;
        if(JSON.parse(this.userInfo).loginLogo!=undefined&&JSON.parse(this.userInfo).loginLogo!=null&&JSON.parse(this.userInfo).loginLogo!=''){
          var link = document.querySelector('link[rel*="icon"]');
          link.href=this.baseUrl+JSON.parse(this.userInfo).loginLogo;
          this.customerLogo = this.baseH + JSON.parse(this.userInfo).loginLogo;
        }else{
          this.customerLogo = 'logo_stu.png';
          var link = document.querySelector('link[rel*="icon"]');
          link.href='logo_stu.png';
        }
        if(JSON.parse(this.userInfo).loginName!=undefined&&JSON.parse(this.userInfo).loginName!=null&&JSON.parse(this.userInfo).loginName!=''){
          var title = document.querySelector('title');
          title.text=JSON.parse(this.userInfo).loginName;
        }else{
          var title = document.querySelector('title');
          title.text='智能心理测评管理系统';
        }
      }
	  },
	  methods:{
		  screenInfo(){
        getScreenInfo().then((res)=>{
          console.log('screenInfo')
          if(res.code == 200){
            this.customerLogo = this.baseUrl+res.data.loginLogo;
            var _loginLogo = this.customerLogo;
            if(_loginLogo!=null&&_loginLogo!==''){
              console.log('this.customerLogo-top')
              console.log(this.customerLogo)
              var link = document.querySelector('link[rel*="icon"]');
              link.href=this.baseUrl+_loginLogo;
            }
          }
        });
		  },
		  editPasd(value){
			  console.log(value)
			  if(value == 'edit'){
				  this.$emit('backPop',true);
			  }
			  if(value == 'exit'){
				  logout().then((res)=>{
					  if(res.code == 200){
						  this.userInfo = '';
              this.customerName='';
						  this.$store.state.userInfo = '';
						 this.$router.push({
						 	path:'/login'
						 })
              this.screenInfo();
					  }
				  })

			  }
		  },
		  init(){
			  var date = new Date()
			  var year = date.getFullYear()
			  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
			  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			  var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
			  this.time = year + '年' + month + '月' + day + '日 ' + hours + ':' + minutes ;
			  let _t = this;
			  setTimeout(function(){
				  _t.init()
			  },1000)
		  }
	  }
	}
</script>

<style scoped>
	img{
		width: 140px;
	}
	.headerTop{
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: fixed;
		top: 10px;
		left: 30px;
		right: 30px;
	}

</style>
